import React, { useEffect } from "react"
import { getAllTimezones } from "../../utils"
import SelectField from "../SelectField"

const timezoneList = getAllTimezones().map(timezone => ({
  value: timezone.text.toLowerCase(),
  label: timezone.text
}))

function TimezoneField(props) {
  useEffect(
    () => {
      if (props.value && props.value.label) {
        for (let i = 0; i < timezoneList.length; i++) {
          if (
            props.value.label !== timezoneList[i].label &&
            props.value.label.toLowerCase() ===
              timezoneList[i].label.toLowerCase()
          ) {
            props.value.label = timezoneList[i].label
            props.form.setFieldTouched(props.field.name)
            props.form.setFieldTouched(props.field.name, false)
          }
        }
      }
    },
    [props.value, props.form, props.field.name]
  )
  return (
    <span className="TimezoneField">
      <SelectField
        {...props}
        isSearchable={true}
        options={timezoneList}
        defaultValue={{ value: "none", label: "" }}
      />
    </span>
  )
}

export default TimezoneField
